import styled from 'styled-components';

export const ImageCarouselWrapper = styled.div`
  [class^='FunctionalCarouselstyle__CarouselWrapper-sc'] {
    [class^='FunctionalCarouselstyle__Carousel-sc'] {
      [class^='FunctionalCarouselstyle__CarouselDotPagerList-sc'] {
        display: none;
      }
    }
  }
`;

export const BackPopupButtonStyles = styled.div`
  button {
    margin: 0 8px;
  }
`;
